<template>
  <v-container>
    <v-dialog
      :value="value"
      @input="$emit('input', $event.target.value)"
      transition="dialog-bottom-transition"
      width="800"
      persistent
    >
      <v-card color="primary">
        <v-toolbar color="primary" flat>
          <v-toolbar-title>
            <h3 v-if="!newEdit">{{ !edit ? "New BOL" : "Add Image" }}</h3>
            <h3 v-else>Edit BOL</h3>
          </v-toolbar-title>
          <v-spacer />

          <v-btn icon @click="reset()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text v-if="!edit">
          <DeliverySearch
            v-if="!newEdit"
            @partner-selected="partnerSelected"
            :conditions="conditions"
            textLabel="Search Freight Carriers"
          ></DeliverySearch>
          <v-select
            color="secondary"
            :items="['Inbound', 'Outbound']"
            v-model="route"
            label="Routing"
            box
          ></v-select>
          <v-select
            color="secondary"
            :items="['Boxes', 'Pallets']"
            v-model="packageType"
            label="Delivery Type"
            box
          ></v-select>
          <v-text-field
            v-model="packageCount"
            label="# of Pallets/Boxes"
            color="secondary"
            box
          ></v-text-field>
          <v-text-field
            v-model="customer"
            label="Customer/Vendor"
            color="secondary"
            box
          ></v-text-field>
          <v-text-field
            v-model="reference"
            label="Sales/Purchase Order #"
            color="secondary"
            box
          ></v-text-field>
          <v-text-field
            v-model="manifest"
            label="Manifest #"
            color="secondary"
            box
          ></v-text-field>
        </v-card-text>
        <v-card-text v-else class="justify-center mt-2">
          <div class="mx-auto justify-center" style="width: 100%; margin: auto">
            <v-text-field
              box
              label="Add Image"
              color="secondary"
              prepend-inner-icon="attach_file"
              v-model="fileName"
              @click="$refs.fileInput.click()"
              clearable
              readonly
            >
              <template v-slot:label>
                <div>
                  Add Image
                </div>
              </template>
            </v-text-field>
            <input
              class="d-none"
              type="file"
              :name="'fileInput'"
              ref="fileInput"
              @change="fileRead"
            />
          </div>
        </v-card-text>
        <v-card-actions class="justify-center mt-2">
          <v-btn @click="reset()">{{ edit ? "Close" : "Cancel" }}</v-btn>
          <v-btn @click="create" color="success" v-if="!edit && !newEdit">Create</v-btn>
          <v-btn @click="update" color="success" v-else-if="newEdit">Update</v-btn>
          <v-btn
            :disabled="!fileForm"
            color="success"
            @click="uploadImage"
            v-else
            >Upload Image</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DeliverySearch from "@/components/app/DeliverySearch";

export default {
  props: {
    value: Boolean,
    otter: Boolean,
    newEdit: Boolean
  },

  components: {
    DeliverySearch
  },

  data() {
    return {
      vendor: "",
      packageCount: "",
      customer: "",
      reference: "",
      packageType: "",
      conditions: [],
      fileName: "",
      fileForm: false,
      s3FileNameServer: "",
      route: "",
      manifest: ""
    };
  },

  computed: {
    ...mapGetters({
      user: "app/getUser",
      createdAudit: "audits/getNewAudit",
      editAudit: "audits/getEditAudit"
    }),

    edit() {
      if(this.newEdit) {
        this.conditions = this.editAudit.conditions;
        this.vendor = this.editAudit.vendor;
        this.packageCount = this.editAudit.packageCount;
        this.customer = this.editAudit.customer;
        this.reference = this.editAudit.reference;
        this.packageType = this.editAudit.packageType;
        this.route = this.editAudit.route;
        this.manifest = this.editAudit.manifest;
        return false;
      } 
      else if (Array.isArray(this.createdAudit)) {
        return false;
      } else return true;
    },

    s3FileName() {
      if (this.createdAudit) {
        let auditCount = this.createdAudit.imageCount;
        if (auditCount > 0) {
          return `${this.createdAudit._id}-${auditCount}`;
        } else {
          return this.createdAudit._id;
        }
      } else {
        return "NONE";
      }
    }
  },

  methods: {
    ...mapActions({
      createBOL: "audits/create",
      updateBOL: "audits/update",
      uploadS3: "audits/uploadS3File"
    }),

    partnerSelected(e) {
      console.log(e);
      this.vendor = e;
    },

    async create() {
      if (!this.vendor) {
        this.$store.dispatch("app/setSnackbar", {
          text: `Please choose a Freight Carrier.`,
          color: "red"
        });
      } else if (!this.packageType) {
        this.$store.dispatch("app/setSnackbar", {
          text: `Please select a package type.`,
          color: "red"
        });
      } else if (!this.packageCount) {
        this.$store.dispatch("app/setSnackbar", {
          text: `Please enter the package count.`,
          color: "red"
        });
      } else {
        await this.createBOL({
          module: "bol",
          body: {
            createdBy: {
              name: this.user.displayName,
              badgeID: this.user.employeeID
            },
            vendor: {
              name: this.vendor.name,
              id: this.vendor.id
            },
            customer: this.customer,
            reference: this.reference,
            packageType: this.packageType,
            packageCount: this.packageCount,
            route: this.route,
            manifest: this.manifest,
            bolType: this.otter ? "otter" : null
          }
        });

        this.$store.dispatch("app/setSnackbar", {
          text: `Successfully Created!`,
          color: "green"
        });
      }
    },
    async update() {
      if (!this.vendor) {
        this.$store.dispatch("app/setSnackbar", {
          text: `Please choose a Freight Carrier.`,
          color: "red"
        });
      } else if (!this.packageType) {
        this.$store.dispatch("app/setSnackbar", {
          text: `Please select a package type.`,
          color: "red"
        });
      } else if (!this.packageCount) {
        this.$store.dispatch("app/setSnackbar", {
          text: `Please enter the package count.`,
          color: "red"
        });
      } else {
        await this.updateBOL({
          id: this.editAudit._id,
          module: "BOL",
          body: {
            customer: this.customer,
            reference: this.reference,
            packageType: this.packageType,
            packageCount: this.packageCount,
            route: this.route,
            manifest: this.manifest,
            imageCount: this.editAudit.imageCount
          }
        });

        this.$store.dispatch("app/setSnackbar", {
          text: `Successfully Updated!`,
          color: "green"
        });
        await this.reset();
      }
    },

    async fileRead(e) {
      let files = e.target.files || e.dataTransfer.files;

      let file = files[0];
      let newFile = null;
      if (files[0]) {
        let type = file.name.split(".").pop();
        let blob = file.slice(0, file.size, file.type);

        newFile = new File([blob], `${this.s3FileName}.${type}`, {
          type: file.type
        });

        this.s3FileNameServer = `${this.s3FileName}.${type}`;
        this.fileName = files[0].name;
        this.fileForm = newFile;
      }
    },

    async uploadImage() {
      if (this.fileForm) {
        if (
          await this.uploadS3({
            module: "BOL",
            body: this.fileForm,
            fileName: this.s3FileNameServer
          })
        ) {
          await this.updateBOL({
            id: this.createdAudit._id,
            module: "BOL",
            body: {
              customer: this.createdAudit.customer,
              reference: this.createdAudit.reference,
              packageType: this.createdAudit.packageType,
              packageCount: this.createdAudit.packageCount,
              route: this.createdAudit.route,
              manifest: this.createdAudit.manifest,
              imageCount: (this.createdAudit.imageCount += 1)
            }
          });
          await this.reset();
        }
      }
    },

    reset() {
      this.$emit("input", false);
      this.$store.commit("audits/setNewAudit", []);
      this.$store.commit("audits/setEditAudit", []);
      Object.assign(this.$data, this.$options.data.apply(this));
      this.$store.dispatch("audits/getAllAudits", {
        rowsPerPage: 10,
        sortBy: "createDate",
        descending: true,
        page: 1,
        from: null,
        to: null,
        search: null,
        module: "bol",
        type: this.otter ? "otter" : null
      });
    }
  }
};
</script>

<style></style>
